import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'frontPage',
        name: 'frontPage',
        component: () => import('@/views/FrontPage'),
        meta: {
          breadcrumb: [{
            name: '首頁',
          }]
        }
      },
      {
        path: 'changePassword',
        name: 'changePassword',
        component: () => import('@/views/ChangePassword'),
        meta: {
          breadcrumb: [{
            name: '修改密碼',
          }]
        }
      },
      {
        path: 'payrollHistoryList',
        name: 'payrollHistoryList',
        component: () => import('@/views/PayrollHistoryList'),
        meta: {
          breadcrumb: [{
            name: '歷史資訊',
          }]
        }
      },
      {
        path: 'payrollHistoryPage',
        name: 'payrollHistoryPage',
        component: () => import('@/views/PayrollHistoryPage'),
        meta: {
          breadcrumb: [{
            name: '歷史資訊',
          },
          {
            name: '詳細資料',
          }]
        }
      },
    ]
  },

  {
    path: '/login',
    component: () => import('@/views/Login'),
  },
  {path: '*', redirect: '/' }

  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/dashboard',
  //   children: [{
  //     path: 'dashboard',
  //     name: 'Dashboard',
  //     component: () => import('@/views/dashboard/index'),
  //     // meta: { title: 'Dashboard', icon: 'dashboard' }
  //   }]
  // },
]

const router = new VueRouter({
  routes
})

export default router
